import { omit } from "lodash";
import { List as PublisherList } from "@madhive/mad-sdk";
import {
  PublisherListsState,
  PublisherListsActionTypes,
  GET_ALL_PUBLISHER_LISTS_PENDING,
  GET_ALL_PUBLISHER_LISTS_FAILURE,
  GET_ALL_PUBLISHER_LISTS_SUCCESS,
  ABORT_PUBLISHER_LISTS_REQUEST,
  SAVE_PUBLISHER_LIST_PENDING,
  SAVE_PUBLISHER_LIST_FAILURE,
  SAVE_PUBLISHER_LIST_SUCCESS,
  GET_PUBLISHER_LIST_BYID_PENDING,
  GET_PUBLISHER_LIST_BYID_FAILURE,
  GET_PUBLISHER_LIST_BYID_SUCCESS,
  SET_PUBLISHER_LISTS_PAGE,
  SET_PUBLISHER_LISTS_PAGE_SIZE
} from "./publisherListsTypes";

export const DEFAULT_PAGE_SIZE = 20;

export const initialState: PublisherListsState = {
  byId: {},
  archivedById: {},
  isAllLoading: false,
  receivedAllAt: null,
  savingById: {},
  getError: null,
  saveError: null,
  isGetByIdLoading: false,
  pagination: {
    currentPage: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    totalCount: 0,
    pageToken: undefined
  }
};

export const publisherListsReducer = (
  state = initialState,
  action: PublisherListsActionTypes
): PublisherListsState => {
  switch (action.type) {
    case GET_ALL_PUBLISHER_LISTS_PENDING:
      return {
        ...state,
        isAllLoading: true,
        getError: null
      };
    case GET_ALL_PUBLISHER_LISTS_FAILURE:
      return {
        ...state,
        isAllLoading: false,
        getError: action.meta.error.message
      };
    case GET_ALL_PUBLISHER_LISTS_SUCCESS: {
      const { pagination } = action.meta;

      // Separate active and archived lists
      const byId: Record<string, PublisherList> = {};
      const archivedById: Record<string, PublisherList> = {};

      action.payload.forEach(publisherList => {
        if (publisherList.status === 500) {
          archivedById[publisherList.id] = publisherList;
        } else {
          byId[publisherList.id] = publisherList;
        }
      });

      return {
        ...state,
        byId,
        archivedById,
        isAllLoading: false,
        receivedAllAt: action.meta.timestamp,
        getError: null,
        pagination: pagination
          ? {
              ...state.pagination,
              totalCount: pagination.count,
              pageToken: pagination.token,
              pageSize: pagination.size
            }
          : state.pagination
      };
    }
    case GET_PUBLISHER_LIST_BYID_PENDING: {
      return {
        ...state,
        isGetByIdLoading: true,
        getError: null
      };
    }
    case GET_PUBLISHER_LIST_BYID_FAILURE: {
      return {
        ...state,
        isGetByIdLoading: false,
        getError: action.meta.error.message
      };
    }
    case GET_PUBLISHER_LIST_BYID_SUCCESS: {
      return {
        ...state,
        isGetByIdLoading: false,
        getError: null,
        byId: { ...state.byId, [action.payload.id]: action.payload }
      };
    }
    case ABORT_PUBLISHER_LISTS_REQUEST:
      return {
        ...state,
        isAllLoading: false,
        getError: null,
        saveError: null
      };
    case SAVE_PUBLISHER_LIST_PENDING:
      if (action.meta.publisherList.id) {
        return {
          ...state,
          savingById: {
            ...state.savingById,
            [action.meta.publisherList.id]: action.meta
              .publisherList as PublisherList
          },
          saveError: null
        };
      }
      return {
        ...state,
        saveError: null
      };
    case SAVE_PUBLISHER_LIST_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.publisherList.id]: action.payload.publisherList
        },
        savingById: omit(state.savingById, action.payload.publisherList.id),
        saveError: null
      };
    case SAVE_PUBLISHER_LIST_FAILURE:
      if (action.meta.publisherListId) {
        return {
          ...state,
          savingById: omit(state.savingById, action.meta.publisherListId),
          saveError: action.meta.error.message
        };
      }
      return {
        ...state,
        saveError: action.meta.error.message
      };
    case SET_PUBLISHER_LISTS_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.page
        }
      };
    case SET_PUBLISHER_LISTS_PAGE_SIZE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: action.payload.pageSize,
          currentPage: 0
        }
      };
    default:
      return state;
  }
};
